<template>
	<div>
		<s-crud title="Query Manager - Configuración" :config="config" @save="save($event)" edit add remove
			:filter="filter" search-input ref="crud" no-full height="auto" @rowSelected="rowSelected($event)">
			<template v-slot:filter>
				<v-col>
					<v-row justify="center">
					</v-row>
				</v-col>
			</template>

			<template scope="props">
				<v-container fluid>
					<span v-show="false">{{ initDefaultValue(props.item) }}</span>
					<v-row dense>
						<v-col cols="12" lg="3" md="4" class="s-col-form">
							<s-select :items="optionList" item-value="OptID" item-text="OptName" label="Módulo"
								v-model="props.item.OptID"></s-select>
						</v-col>

						<v-col cols="12" lg="3" md="4" class="s-col-form" justfy="center" style="margin: initial;">
							<s-text v-model="props.item.QryNameSp" label="Nombre Procedure">
							</s-text>
						</v-col>

						<v-col cols="12" lg="3" md="4" class="s-col-form" justfy="center" style="margin: initial;">
							<s-text v-model="props.item.QryNameReport" label="Nombre Reporte">
							</s-text>
						</v-col>

						<v-col cols="12" lg="3" md="4" class="s-col-form" justfy="center" style="margin: initial;">
							<s-select-definition label="Base de Datos" :def="1368"
								v-model="props.item.QryDatabaseName"></s-select-definition>
						</v-col>

						<v-col cols="12" lg="6" md="8" class="s-col-form">
							<s-text label="Parámetros" v-model="props.item.QryParamsArray"></s-text>
						</v-col>

						<v-col cols="12" lg="3" md="3" class="s-col-form">
							<v-switch label="Mostrar Título Excel" v-model="props.item.QryViewTitleExcel" inset
								hide-details></v-switch>
						</v-col>

						<v-col cols="12" lg="3" md="3" class="s-col-form">
							<v-switch label="Mostrar Subtítulo Excel" v-model="props.item.QryViewSubtitleExcel" inset
								hide-details></v-switch>
						</v-col>

						<v-col cols="12" lg="3" md="3" class="s-col-form">
							<v-switch label="Mostrar Bordes Excel" v-model="props.item.QryViewBorderExcel" inset
								hide-details></v-switch>
						</v-col>

						<v-col cols="12" lg="3" md="3" class="s-col-form">
							<div style="padding-top:-2px;margin-top:-2px;">
								<v-label>
									<b>Background Cabezeras Excel</b>
								</v-label>
								<v-menu v-model="menuBackground" :close-on-content-click="false" :nudge-right="40"
									transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="props.item.QryBgHeader"
											prepend-inner-icon="mdi-format-color-fill" readonly v-bind="attrs" v-on="on"
											outlined dense hide-details="auto">
											<template v-slot:append>
												<v-icon :color="props.item.QryBgHeader" v-bind="attrs"
													v-on="on">mdi-circle</v-icon>
											</template>
										</v-text-field>
									</template>
									<v-color-picker v-model="props.item.QryBgHeader" hide-inputs></v-color-picker>
								</v-menu>
							</div>
						</v-col>

						<v-col cols="12" lg="3" md="3" class="s-col-form">
							<div style="padding-top:-2px;margin-top:-2px;">
								<v-label>
									<b>Texto Cabezeras Excel</b>
								</v-label>
								<v-menu v-model="menuColor" :close-on-content-click="false" :nudge-right="40"
									transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="props.item.QryColorHeader"
											prepend-inner-icon="mdi-format-color-fill" readonly v-bind="attrs" v-on="on"
											outlined dense hide-details="auto">
											<template v-slot:append>
												<v-icon :color="props.item.QryColorHeader" v-bind="attrs"
													v-on="on">mdi-circle</v-icon>
											</template>
										</v-text-field>
									</template>
									<v-color-picker v-model="props.item.QryColorHeader" hide-inputs></v-color-picker>
								</v-menu>
							</div>
						</v-col>
					</v-row>
					<!-- <v-row>
						<v-col cols="3">
							<s-text label="Fecha Fin" v-model="props.item.QryDateEndNameParam"></s-text>
						</v-col>
					</v-row> -->
				</v-container>
			</template>

			<template v-slot:accion="{ row }">
				<v-btn color="success" @click="openModalParameter(row)" x-small>
					<i class="fas fa-paragraph"></i>
				</v-btn>
			</template>

		</s-crud>

		<v-dialog persistent v-model="dialogParameter" width="800">
			<v-card>
				<s-toolbar label="Agregar Parametros" color="#BAB6B5" close @close="closeModalParameter()" add
					@add="add()" remove @removed="deleteParameter()">

				</s-toolbar>
				<v-container>
					<v-row align="center" justify="center">
						<v-col cols="12" md="3">
							<s-text number v-model="parameter.CfdPosition" label="Posicion"></s-text>
						</v-col>
						<v-col cols="12" md="3">
							<s-select-definition label="Tipo de Parametro" :def="1238"
								v-model="parameter.TypeParameter"></s-select-definition>
						</v-col>
						<v-col cols="12" md="3">
							<s-text label="Nombre de Parametro" v-model="parameter.CfdParameterName">
							</s-text>
						</v-col>
						<v-col v-if="parameter.TypeParameter == 2" cols="2">
							<s-text number v-model="parameter.CfdDefID" label="Definición"></s-text>
						</v-col>
					</v-row>
					<v-row align="center" justify="center" v-if="parameter.TypeParameter == 4">
						<v-col cols="4">
							<s-text v-model="parameter.CfdItemValue" label="Item-Value"></s-text>
						</v-col>
						<v-col cols="4">
							<s-text v-model="parameter.CfdItemText" label="Item-Text"></s-text>
						</v-col>
					</v-row>
					<v-row align="center" justify="center" v-if="parameter.TypeParameter == 4">
						<v-col cols="9">
							<s-textarea v-model="parameter.CfdQuerySql" label="Consulta"></s-textarea>
						</v-col>
					</v-row>
					<v-row align="center" justify="center" v-if="parameter.TypeParameter == 5">
						<v-col cols="4">
							<s-text v-model="parameter.CfdItemValue" label="Item-Value"></s-text>
						</v-col>
						<v-col cols="4">
							<s-text v-model="parameter.CfdItemText" label="Item-Text"></s-text>
						</v-col>
						<v-col cols="1" align-self="end">
							<button style="background-color: #4ECA8A; padding: 5px 10px; border-radius: 5px;"
								@click="addParameter()">
								<v-icon color="white">mdi-plus-circle-outline</v-icon>
							</button>
						</v-col>
					</v-row>
					<v-row align="center" justify="center" v-if="parameter.TypeParameter == 5">
						<v-col cols="8">
							<v-data-table :headers="headers" :items="jsonSelectMultiple" dense :itemsPerPage="[5]">
								<template v-slot:item.actions="{ item }">
									<v-btn color="red" @click="deleteItem(item.value)" icon>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-data-table :headers="headersParameter" :items="itemsParameter"
								v-model="selecteItemParameter" dense @click:row="rowSelectParameter($event)"
								item-key="CfdID">
								<!-- <template v-slot:item.>
									<div>
										
									</div>
								</template> -->
							</v-data-table>
						</v-col>
					</v-row>
				</v-container>
			</v-card>
		</v-dialog>
	</div>
</template>


<script>
import _service from "@/services/QueryManager/QryConfigurationService";
import _sOption from "@/services/Security/OptionService.js";
import _sQryConfigurationDetailService from "@/services/QueryManager/QryConfigurationDetailService";

export default {

	data() {
		return {
			optionList: [],
			filter: { TypeArea: 0 },
			config: {
				model: {
					QryID: "ID",
					OptID: "int",
					accion: "string",
					QryShowExcelHeader: "boolean",
					QryShowExcelSubtitle: "boolean",
					QryBgHeader: "string"
				},
				service: _service,
				headers: [
					{ text: "Parámetros", value: "accion" },
					{ text: "ID", value: "QryID" },
					{ text: "Módulo", value: "OptName" },
					{ text: "Nombre Query", value: "QryNameSp" },
					{ text: "Nombre Reporte", value: "QryNameReport" },
					{ text: "Database", value: "QryDatabaseNameName" },
					{ text: "Parámetros", value: "QryParamsArray" },

				]
			},
			dialogParameter: false,
			menuBackground: false,
			menuColor: false,
			headersParameter: [
				{ text: "Tipo Parametro", value: "TypeParameterName" },
				{ text: "Nombre Parametro", value: "CfdParameterName" },
				{ text: "Posición", value: "CfdPosition" },
				{ text: "Value", value: "CfdItemValue" },
				{ text: "Text", value: "CfdItemText" },
				{ text: "Consulta", value: "CfdQuerySql" },
			],
			itemsParameter: [],
			parameter: {},
			query: {},
			selecteItemParameter: [],
			jsonSelectMultiple: [],
			headers: [
				{ text: "Valor", value: "value" },
				{ text: "Texto", value: "text" },
				{ text: "Acciones", value: "actions", sortable: false, width: 70 },
			]
		};
	},


	created() {

		this.initialize();


	},

	methods: {
		initDefaultValue(item) {
			if (!item.QryBgHeader) {
				this.$set(item, "QryBgHeader", "#191970");
			}
			if (!item.QryColorHeader) {
				this.$set(item, "QryColorHeader", "#FFFFFF");
			}
		},

		deleteItem(item) {
			this.jsonSelectMultiple.splice(this.jsonSelectMultiple.indexOf(item), 1)
		},
		addParameter() {
			if (this.parameter.CfdItemValue == "" || this.parameter.CfdItemText == "") {
				this.$fun.alert("Ingrese Item-Value y Item-Text", "warning");
				return;
			}
			const data = {}
			data.text = this.parameter.CfdItemText;
			data.value = this.parameter.CfdItemValue;
			this.jsonSelectMultiple.push(data);
			this.parameter.CfdItemValue = "";
			this.parameter.CfdItemText = "";
		},
		rowSelected(item) {
			// console.log("item", item);
			this.selecteItemParameter = [item];
		},

		initialize() {
			_sOption.list(1, this.$fun.getUserID()).then((r) => {
				this.optionList = r.data;
				// console.log(this.optionList);
			});
		},

		save(item) {
			if (item.OptID == 0) {
				this.$fun.alert("Seleccione un módulo", "warning");
				return;
			}
			if (item.QryNameSp == "") {
				this.$fun.alert("Ingrese nombre del query", "warning");
				return;
			}
			if (item.QryNameReport == "") {
				this.$fun.alert("Ingrese nombre del reporte", "warning");
				return;
			}
			if (item.QryBgHeader == "") {
				this.$fun.alert("Seleccionar background de cabeceras", "warning");
				return;
			}
			if (item.QryColorHeader == "") {
				this.$fun.alert("Seleccionar color de cabeceras", "warning");
				return;
			}

			item.QryViewTitleExcel = item.QryViewTitleExcel ? 1 : 0;
			item.QryViewSubtitleExcel = item.QryViewSubtitleExcel ? 1 : 0;
			item.QryViewBorderExcel = item.QryViewBorderExcel ? 1 : 0;
			// console.log(JSON.parse(JSON.stringify(item)));
			item.save();
		},

		openModalParameter(item) {
			this.dialogParameter = true;
			this.query = item;
			this.getDataParameter();
			// console.log("🚀 ~ file: QryConfiguration.vue ~ line 236 ~ this.query", this.query)
		},


		closeModalParameter() {
			this.dialogParameter = false;
		},

		rowSelectParameter(item) {
			// console.log("item", item);
			this.parameter = item;
			if (item.TypeParameter == 5) {
				// console.log("item.CfdQuerySql", item.CfdQuerySql);
				this.jsonSelectMultiple = JSON.parse(item.CfdQuerySql);
			}
		},

		add() {
			if (this.parameter.CfdParameterName == "") {
				this.$fun.alert("Ingrese nombre del parametro", "warning");
				return;
			}

			if (this.parameter.TypeParameter == null) {
				this.$fun.alert("Ingrese tipo de parametro", "warning");
				return;
			}

			if (this.parameter.TypeParameter == 5) {
				if (this.jsonSelectMultiple.length > 0) {
					this.parameter.CfdQuerySql = JSON.stringify(this.jsonSelectMultiple);
				} else {
					this.$fun.alert("Debe ingresar al menos un item", "warning");
					return;
				}
			}

			this.parameter.QryID = this.query.QryID;
			this.parameter.SecStatus = 1;
			this.parameter.UsrCreateID = this.$fun.getUserID();
			this.parameter.UsrUpdateID = this.$fun.getUserID();
			this.parameter.CfdDefID = this.parameter.CfdDefID != null ? this.parameter.CfdDefID : 0
			// console.log("🚀 ~ file: QryConfiguration.vue ~ line 293 ~ this.parameter", this.parameter)



			_sQryConfigurationDetailService
				.save(this.parameter, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.$fun.alert("Parametro agregado correctamente", "success");
						this.getDataParameter();
						this.parameter = {};
						this.jsonSelectMultiple = [];
						return;
					}
				})
		},

		deleteParameter() {
			this.parameter.SecStatus = 0;
			this.parameter.UsrUpdateID = this.$fun.getUserID();
			_sQryConfigurationDetailService
				.save(this.parameter, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.$fun.alert("Parametro eliminado correctamente", "success");
						this.getDataParameter();
						return;
					}
				})
		},

		getDataParameter() {
			_sQryConfigurationDetailService
				.list(this.query, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.itemsParameter = resp.data;
					}
				})
		}
	},
	watch: {
		'parameter.TypeParameter'() {
			if (this.parameter.TypeParameter != 5) {
				this.jsonSelectMultiple = [];
			}
			this.parameter.CfdItemValue = "";
			this.parameter.CfdItemText = "";
		}
	}
};
</script>
